import React from "react";
import { Dropdown } from "semantic-ui-react";

interface InspectionItemStaffFailedDropdownButtonProps {
  isPassLoading?: boolean;
  onPass?: () => void;
}
export default function InspectionItemStaffFailedDropdownButton({
  isPassLoading,
  onPass,
}: InspectionItemStaffFailedDropdownButtonProps) {
  return (
    <Dropdown
      button
      text='Failed'
      className='tw-bg-[#DF0202] tw-px-[22px] tw-text-[#fff]'
      loading={isPassLoading}
      size='tiny'
    >
      <Dropdown.Menu>
        <Dropdown.Item label={{ color: "green", empty: true, circular: true }} text='Passed' onClick={onPass} />
      </Dropdown.Menu>
    </Dropdown>
  );
}
